"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeSourceEnum = void 0;
var ExchangeSourceEnum;
(function (ExchangeSourceEnum) {
    ExchangeSourceEnum["Coinapi"] = "Coinapi";
    ExchangeSourceEnum["IexCloud"] = "IexCloud";
    ExchangeSourceEnum["Eod"] = "Eod";
})(ExchangeSourceEnum = exports.ExchangeSourceEnum || (exports.ExchangeSourceEnum = {}));
//# sourceMappingURL=exchange-source-enum.js.map